import React from "react";
import { useTranslation } from "react-i18next";

import FaqCategory from "../../../components/v2/Duvidas/FaqCategory";
import Layout from "../../../components/v2/Layout";
import PageTitle from "../../../components/v2/PageTitle";
import { faqCategories } from "../../../content/faq";

import style from "./styles.module.scss";

const keyI18n = "translations.faq";

export default function Faq() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />

        <ul className={style.list}>
          {faqCategories.map((category) => (
            <FaqCategory category={category} key={category.slug} />
          ))}
        </ul>
      </div>
    </Layout>
  );
}
